import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ErrorComponent } from './error/error.component';
import { SuccessComponent } from './success/success.component';
import { TokenLoginComponent } from './token/token-login.component';
import { EnterEmailComponent } from './enter-email/enter-email.component';
import { ApplyComponent } from './apply/apply.component';
import { registerLocaleData } from '@angular/common';
import localeHr from '@angular/common/locales/hr';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { InfoButtonComponent } from './info-button/info-button.component';
import { NotActiveComponent } from './not-active/not-active.component'

registerLocaleData(localeHr);
@NgModule({
  declarations: [
    AppComponent,
    ApplyComponent,
    ErrorComponent,
    TokenLoginComponent,
    EnterEmailComponent,
    SuccessComponent,
    InfoButtonComponent,
    NotActiveComponent,
   ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    NgxPaginationModule,
    OrderModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
  ],
  providers: [
     ],
  bootstrap: [AppComponent],
})
export class AppModule {


}

